export const PollBulkMetadataPropertyDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'PollBulkMetadataProperty' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'referrer' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchArgsWhere' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'search' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'query' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'referrer' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'referrer' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'limit' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'offset' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'totalHitsCount' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'results' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SearchResultDocument' } },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentContractOwner' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentCountry' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentDocumentCategory' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentType' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentMaterialAgreement' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentOriginalVersionStored' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentActive' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentNoticeDate' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'metadataDocumentProbationaryPeriodExpirationDate' },
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentStartDate' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentTerminationDate' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentCurrency' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentDiscount' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentFeeAdjustmentClause' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'metadataDocumentPaymentTermsDaysFromInvoiceDate' },
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentTotalContractCost' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentTotalContractValue' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentAutomaticRenewal' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentNoticePeriodDays' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentNoticePeriodMonths' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentOriginalTermMonths' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'metadataDocumentPostTerminationObligations' },
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentRenewalTermMonths' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentTerminationForCause' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'metadataDocumentTerminationForConvenience' },
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentIndemnity' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentLiabilityCap' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentLiabilityCapScope' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentLimitationOfLiability' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentProbationaryPeriod' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentDeviateFromStandard' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentGoverningLaw' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentOutsourcing' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'metadataDocumentProcessingOfPersonalData' },
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadataDocumentParties' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
